module.exports = __webpack_public_path__ + "img/clock.45bcabda.svg";